/** Reiwa-era year helpers for employment-contract admin dates. Reiwa 1 = 2019. */

const REIWA_EPOCH_YEAR = 2018; // gregorianYear - 2018 = Reiwa year

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/**
 * Format ISO `yyyy-mm-dd` as `8年 07月 31日` (no 令和 — the form/PDF already shows the era).
 * Empty → placeholder.
 */
export function formatIsoAsReiwaDisplay(iso: string | undefined | null): string {
  const raw = (iso ?? '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return '　年　　月　　日';
  }
  const [yStr, mStr, dStr] = raw.split('-');
  const year = Number(yStr);
  const month = Number(mStr);
  const day = Number(dStr);
  if (!year || !month || !day) {
    return '　年　　月　　日';
  }
  const reiwa = year - REIWA_EPOCH_YEAR;
  if (reiwa < 1) {
    return `${Math.max(reiwa, 1)}年 ${pad2(month)}月 ${pad2(day)}日`;
  }
  return `${reiwa}年 ${pad2(month)}月 ${pad2(day)}日`;
}
